export default __webpack_public_path__ + "waitingarea1.json";